import createReducer from '../../utils/createReducer';
import {
    UPDATE_RECORDED_VIDEO_INFO_PARAM,
    UPDATE_RECORDED_VIDEO_PARAM,
} from '../actions/recordedVideo';

const initialState = {
    volumeLevel: 100,
    thumbnail: '',
};

const handlers = {
    [UPDATE_RECORDED_VIDEO_PARAM]: (state, { payload }) => {
        console.log('UPDATE_RECORDED_VIDEO_INFO_PARAM', state, payload);
        return {
            volumeLevel: state.volumeLevel,
            thumbnail: payload ? state.thumbnail : '',
            ...payload,
        };
    },
    [UPDATE_RECORDED_VIDEO_INFO_PARAM]: (state, { payload }) => {
        console.log('UPDATE_RECORDED_VIDEO_INFO_PARAM', state, payload);
        return {
            ...state,
            ...payload,
            thumbnail: payload ? payload.thumbnail : '',
        };
    },
};

export default createReducer(initialState, handlers);
